export default __webpack_public_path__ + "static/media/portrait.fa05a94c.jpg";